import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import axios, { baseUrl } from '../../../../redux/my-axios';
import Filter from './filter/Filter';
import List from './list/List';
import Total from './total/Total';

export const URL = '/finance';
const initialFilter = {
  filter: {
    from: '', //Date.now(),
    to: '', //"",
    searchText: '',
  },
  sortOrder: 'desc', // asc||desc
  sortField: 'code',
  pageNumber: 1,
  pageSize: 400,
};
export const FinanceStocksPage = (props) => {
  const [queryParams, setQueryParams] = useState(initialFilter);
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const [entities, setEntities] = useState([]);
  const [total, setTotal] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    axios
      .post(URL, queryParams, { headers: { action: 'getstocks' } })
      .then((response) => {
        switch (response.data.type) {
          case 'SUCCESS':
          case 'SUCCESS_WITH_WARNING':
          case 'SUCCESS_WITH_INFO':
            console.log('Result ', response.data.data);
            setTotalCount(response.data.data.totalCount);
            setEntities(response.data.data.list);
            buildTotal(response.data.data.list);
            break;
          default:
            var error = response.data.msg.desc;
            setError(error);
            break;
        }
      })
      .catch((error) => {
        setError(error);
      });
    return () => {
      setEntities([]);
    };
  }, [queryParams]);

  const buildTotal = (entities) => {
    var sumProduct = 0.0;
    var sumStock = 0.0;
    var sumPurchase = 0.0;

    for (let i = 0; i < entities.length; i++) {
      if (entities[i].productAmount)
        sumProduct +=
          Math.round(
            (parseFloat(entities[i].productAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].stockAmount)
        sumStock +=
          Math.round(
            (parseFloat(entities[i].stockAmount) + Number.EPSILON) * 100
          ) / 100;
      if (entities[i].purchaseItemAmount)
        sumPurchase +=
          Math.round(
            (parseFloat(entities[i].purchaseItemAmount) + Number.EPSILON) * 100
          ) / 100;
    }
    setTotal([
      {
        productAmount: sumProduct,
        stockAmount: sumStock,
        purchaseItemAmount: sumPurchase,
      },
    ]);
  };

  return (
    <Card id='financeStockCard'>
      <CardHeader title='САНХҮҮ: Бараа Бүтээгдэхүүн'></CardHeader>
      <CardBody id='financeStockCardBody'>
        <Filter queryParams={queryParams} setQueryParams={setQueryParams} />
        {/*    <h6>Нийт дүн</h6>
        <Total
          key='financeStockCardBodyTotal'
          entities={total}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
        <b>Өдөр бүрийн дүн</b> */}
        <List
          key='financeStockCardBodyList'
          entities={entities}
          totalCount={totalCount}
          setQueryParams={setQueryParams}
        />
      </CardBody>
    </Card>
  );
};
